export const formatConfirmActionContentCopyText = (submitLabel, cancelLabel) =>
  `[${submitLabel}] / [${cancelLabel}]`;
